/// <amd-module name="Feed/Legacy/Utils/Hub" />
import { IHubState } from "Feed/Legacy/Types/IHubState";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";

export function toNavState(pageContext: IVssPageContext, hubState: IHubState): { [key: string]: string } {
    const navState = pageContext.getService<IVssHistoryService>("IVssHistoryService").getState();
    delete navState._a;
    delete navState.feed;
    delete navState.package;
    delete navState.preferRelease;
    delete navState.protocolType;
    delete navState.upstreamSource;
    delete navState.version;
    delete navState.view;
    delete navState.showFilters;

    navState._a = hubState.action;
    if (hubState.feed) {
        navState.feed = hubState.feed;
    }
    if (hubState.package) {
        navState.package = hubState.package;
    }
    if (hubState.preferRelease) {
        navState.preferRelease = hubState.preferRelease;
    }
    if (hubState.protocolType) {
        navState.protocolType = hubState.protocolType;
    }
    if (hubState.upstreamSource) {
        navState.upstreamSource = hubState.upstreamSource;
    }
    if (hubState.version) {
        navState.version = hubState.version;
    }
    if (hubState.view) {
        navState.view = hubState.view;
    }

    return navState;
}

export function toHubState(navState: { [key: string]: string }): IHubState {
    return {
        action: navState._a,
        feed: navState.feed,
        package: navState.package,
        version: navState.version,
        upstreamSource: navState.upstreamSource,
        protocolType: navState.protocolType,
        preferRelease: navState.preferRelease,
        view: navState.view
    } as IHubState;
}
